<template>
  <div class="modal-wheel">
    <p>{{ result }}</p>
  </div>
</template>

<script>
export default {
  name: 'ModalWheel',
  props: ['result'],
};
</script>

<style lang="scss" scoped>
.modal-wheel {
  padding: 40px 30px 30px;
  text-align: center;
}
</style>
